// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAnalytics$dTypes$dCrossSellingKind from "../Restaumatic.Analytics.Types.CrossSellingKind/index.js";
import * as Restaumatic$dAnalytics$dTypes$dCrossSellingPlace from "../Restaumatic.Analytics.Types.CrossSellingPlace/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ItemList = (tag, _1) => ({tag, _1});
const MenuIsSymbol = {reflectSymbol: () => "Menu"};
const kindIsSymbol = {reflectSymbol: () => "kind"};
const placeIsSymbol = {reflectSymbol: () => "place"};
const CrossSellingIsSymbol = {reflectSymbol: () => "CrossSelling"};
const LastOrderIsSymbol = {reflectSymbol: () => "LastOrder"};
const Menu = /* #__PURE__ */ $ItemList("Menu");
const CrossSelling = value0 => $ItemList("CrossSelling", value0);
const LastOrder = /* #__PURE__ */ $ItemList("LastOrder");
const toFillFormTypeItemList = {fillFormDataType: v => "unknown"};
const eqItemList = {
  eq: x => y => {
    if (x.tag === "Menu") { return y.tag === "Menu"; }
    if (x.tag === "CrossSelling") {
      if (y.tag === "CrossSelling") {
        return (() => {
          if (x._1.kind.tag === "Nothing") { return y._1.kind.tag === "Nothing"; }
          if (x._1.kind.tag === "Just") {
            if (y._1.kind.tag === "Just") {
              if (x._1.kind._1.tag === "Automatic") { return y._1.kind._1.tag === "Automatic"; }
              if (x._1.kind._1.tag === "Manual") { return y._1.kind._1.tag === "Manual"; }
              return false;
            }
            return false;
          }
          return false;
        })() && (() => {
          if (x._1.place.tag === "Creator") { return y._1.place.tag === "Creator"; }
          if (x._1.place.tag === "Cart") { return y._1.place.tag === "Cart"; }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "LastOrder") { return y.tag === "LastOrder"; }
    return false;
  }
};
const genericItemList = {
  to: x => {
    if (x.tag === "Inl") { return Menu; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ItemList("CrossSelling", x._1._1); }
      if (x._1.tag === "Inr") { return LastOrder; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Menu") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "CrossSelling") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "LastOrder") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showItemList = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(MenuIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ kind: " + (() => {
          if (v.kind.tag === "Just") { return "(Just " + Restaumatic$dAnalytics$dTypes$dCrossSellingKind.showCrossSellingKind.show(v.kind._1) + ")"; }
          if (v.kind.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })() + ", place: " + Restaumatic$dAnalytics$dTypes$dCrossSellingPlace.showCrossSellingPlace.show(v.place) + " " + "}"
      ]
    })(CrossSellingIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(LastOrderIsSymbol);
    return x => {
      const $3 = genericItemList.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeItemList = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(MenuIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(CrossSellingIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(kindIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dAnalytics$dTypes$dCrossSellingKind.unscrambleDecodeCrossSellingKind))(Unscramble.decodeRecordCons(placeIsSymbol)(Restaumatic$dAnalytics$dTypes$dCrossSellingPlace.unscrambleDecodeCrossSellingPlace)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(LastOrderIsSymbol))))(Unscramble$dGeneric.defaultOptions);
    return x => genericItemList.to($0(x));
  })()
};
const encodeItemList = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericItemList)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(MenuIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(CrossSellingIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(placeIsSymbol)({
        encodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dCrossSellingPlace.encodeCrossSellingPlace.encode
      }))(kindIsSymbol)({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dAnalytics$dTypes$dCrossSellingKind.encodeCrossSellingKind.encode(v2._1); }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(LastOrderIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeItemList = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericItemList)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MenuIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CrossSellingIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(placeIsSymbol)({
    decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dCrossSellingPlace.decodeCrossSellingPlace.decode
  })())(kindIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dAnalytics$dTypes$dCrossSellingKind.decodeCrossSellingKind.decode)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(LastOrderIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))))
};
export {
  $ItemList,
  CrossSelling,
  CrossSellingIsSymbol,
  LastOrder,
  LastOrderIsSymbol,
  Menu,
  MenuIsSymbol,
  decodeItemList,
  encodeItemList,
  eqItemList,
  genericItemList,
  kindIsSymbol,
  placeIsSymbol,
  showItemList,
  toFillFormTypeItemList,
  unscrambleDecodeItemList
};
